interface StorybookViteEnvironment {
  STORYBOOK?: 'true' | 'false';
  VITE_GOOGLE_API_KEY?: string;
}

/**
 * Check if the app is running in Storybook.
 */
export const isStorybook = () => {
  const env = getViteEnvironment();

  return env?.STORYBOOK === 'true';
};

/**
 * When running in Storybook, return the environment variables.
 * @returns
 */
export const getViteEnvironment = (): StorybookViteEnvironment => {
  // Get environment variables from Vite: https://vitejs.dev/guide/env-variables.html#loading-env-variables
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  const env = (import.meta as any).env;

  return env ?? {};
};

export const getViteEnvironmentValue = (key: string) => {
  const environment = getViteEnvironment();
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  return (environment as any)[`VITE_${key}`] ?? 'not-set';
};
